export const Mission = () => {
  return (
    <section>
      <h2>Our mission</h2>
      <p>
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Earum minima
        quibusdam aliquid enim! Rem corrupti iste labore, esse voluptatem nisi!
        Nam consectetur aliquid commodi! Consequuntur, odit magnam placeat
        temporibus reiciendis harum recusandae minus autem, adipisci voluptate
        dignissimos accusamus dolorem iusto at repellat illum fugit eius
        nostrum! Iusto numquam repellat consectetur nisi error porro, quae
        recusandae molestiae necessitatibus perspiciatis dolore magnam!
      </p>
    </section>
  );
};
